import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import ErrorBoundary from '.';
export function withErrorBoundary(Component, debugComponent) {
    const decorated = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: debugComponent
        }, /*#__PURE__*/ React.createElement(Component, _extends({}, props)));
    decorated.displayName = `withErrorBoundary(${Component.displayName || 'Component'})`;
    return decorated;
}
